// 成员管理页
<template>
  <div>
    <p
      class="process_list"
      v-if="allAuthUser"
      style="
        background-color: #fff5e6;
        border-color: #ffebcc;
        padding: 5px;
        margin-bottom: 10px;
      "
    >
      <i class="el-icon-warning" style="color: #f8b762; margin: 0 10px"></i>
      <span class="process_list_num">1</span>
      <span v-if="isInDingTalk">创建组织架构</span>
      <a v-else href="https://www.junziqian.com/help_detail-32.html" target="_blank">创建组织架构</a>
      <i class="el-icon-right icon_size"></i>
      <span class="process_list_num">2</span>
      <span v-if="isInDingTalk">邀请企业成员加入</span>
      <a v-else href="https://www.junziqian.com/help_detail-33.html" target="_blank">邀请企业成员加入</a>
      <i class="el-icon-right icon_size"></i>
      <span class="process_list_num">3</span>
      <span v-if="isInDingTalk">为成员分配权限</span>
      <a v-else href="https://www.junziqian.com/help_detail-36.html" target="_blank">为成员分配权限</a>
    </p>
    <el-tabs v-model="tabAct" style="background-color: #ffffff; min-height: calc(100vh - 210px);">
      <!--
        拥有某个权限可以显示。
        为了兼容以前的数据，在两个子权限都没有的情况下，可以显示出来
        （如果只有父级权限说明是以前的数据。可以拥有子权限）
        -->
      <!-- v-if="
          perms.includes(gantConf.organStru) ||
            (!perms.includes(gantConf.organStru) &&
              !perms.includes(gantConf.roleManage) &&
              perms.includes(gantConf.memberManage))
        " -->
      <!-- <el-tab-pane label="组织架构" name="member-architecture">
        <organization
          v-if="tabAct === 'member-architecture'"
          :hideBlackTitle="true"
        ></organization>
      </el-tab-pane> -->
      <!-- v-if="
          perms.includes(gantConf.organStru) ||
            (!perms.includes(gantConf.organStru) &&
              !perms.includes(gantConf.roleManage) &&
              perms.includes(gantConf.memberManage))
        " -->
      <el-tab-pane label="组织及成员" name="member">
        <member-com v-if="tabAct === 'member'"></member-com>
      </el-tab-pane>
      <!-- v-if="perms.includes(gantConf.roleManage)" -->
      <el-tab-pane label="权限组" name="role">
        <role-com></role-com>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// 组件
import memberCom from "../../components/console/memberManage/memberCom.vue";
import roleCom from "../../components/console/memberManage/roleCom.vue";
import organization from "./organization";
import { gantConf } from "../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
import Bus from "@/plugins/bus.js";
import { isInDingTalk, authentication } from "@/assets/js/utils/ding-env";

export default {
  data () {
    return {
      isInDingTalk,
      gantConf,
      tabAct: "member"
    };
  }, // data end
  methods: {
    turnTab () {
      let _this = this;
      Bus.$on("listenClickTab", tab => {
        _this.$nextTick(() => {
          _this.tabAct = tab;
        });
      });
    },
    initTab () {
      if (isInDingTalk) {
        this.$nextTick(() => {
          this.tabAct = "member";
        });
        return;
      }
      // this.tabAct =
      //   this.perms.includes(gantConf.organStru) ||
      //     (!this.perms.includes(gantConf.organStru) &&
      //       !this.perms.includes(gantConf.roleManage) &&
      //       this.perms.includes(gantConf.memberManage))
      //     ? "member-architecture"
      //     : "role";
    }
  },
  created () {
    this.initTab();
    this.turnTab();
  },
  components: {
    memberCom,
    roleCom,
    organization
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    }
  },
};
</script>

<style lang="less">
.el-tabs__header {
  margin: 0;
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
.el-tabs__nav-scroll {
  background-color: #fff;
}
.el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 12px !important;
}
.el-tabs__active-bar {
  display: none;
}
.el-tabs__item.is-active {
  color: #ec1c1c;
}
.el-tabs__item:hover {
  color: #ec1c1c;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
  .process_list {
    color: #606266;
    font-size: 14px;
    .process_list_num {
      display: inline-block;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      border: 2px solid #606266;
      border-radius: 50%;
      margin-right: 6px;
    }
    .icon_size {
      margin: 0 20px;
      font-weight: bold;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/console/member.vue